export class ConcurrentCallLimit<T>
{
    callLimit: number;
    currentCalls: number = 0;
    callQueue: StoredConcurrentCall<T>[] = [];

    constructor(callLimit: number)
    {
        this.callLimit = callLimit;
    }

    run(action: () => Promise<T>): Promise<T>
    {
        const self = this;

        if (self.currentCalls < this.callLimit)
        {
            self.currentCalls++;
            const promise = action();
            promise.finally(() =>
            {
                self.currentCalls--;
                self.triggerNextCall();
            });
            return promise;
        }
        else
        {
            const limit = new StoredConcurrentCall<T>;
            limit.action = action;
            self.callQueue.push(limit);

            return new Promise<T>((resolve, reject) =>
            {
                limit.resolve = resolve;
                limit.reject = reject;
            });
        }
    }

    async triggerNextCall(): Promise<void>
    {
        if (this.callQueue.length > 0)
        {
            const self = this;
            const nextCall = self.callQueue.shift();
            self.currentCalls++;
            const callAction = nextCall.action();
            callAction.finally(() =>
            {
                self.currentCalls--;
                self.triggerNextCall();
            });
            callAction.then((result) =>
            {
                nextCall.resolve(result);
            }, reject =>
            {
                nextCall.reject(reject);
            });
        }
    }
}

class StoredConcurrentCall<T>
{
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason: string) => void;
    action: () => Promise<T>;

}
